import { QuestionError } from '@sm/question-definitions';

// copied from: smpackages/packages/utils/src/object/deepFreeze.ts
export type DeepReadOnly<T> = { readonly [P in keyof T]: DeepReadOnly<T[P]> };

export type ValidationStatuses = 'ok' | 'error';

export const ValidationStatus = {
  OK: 'ok' as ValidationStatuses,
  Error: 'error' as ValidationStatuses,
};

export type ValidationMessageTypeSeverity = 'info' | 'warn' | 'error';

export type ValidationMessageType = Pick<QuestionError, 'id' | 'message'> & {
  source: 'local';
  type: ValidationMessageTypeSeverity;
  field: string | null;
};

export type AnswerValidationResultType = {
  status: ValidationStatuses;
  messages?: DeepReadOnly<ValidationMessageType[]> | null;
  isValid(): boolean;
  getFirstMessage(): ValidationMessageType | undefined;
};

export type ValidationResultTuple = [boolean, ValidationMessageType[] | null];

export type QuestionValidator = (forceValidation?: boolean, value?: string) => QuestionError[] | null;

export type QuestionValidators = {
  validators: QuestionValidator[];
  lastResult?: ValidationResultTuple | null;
};

export type QuestionsValidators = {
  [key: string]: QuestionValidators;
};
